import { put } from 'redux-saga/effects';
import { actionTypes as appActionTypes, ready } from 'Modules/App/actions';

export default function* lightningOutUpstart() {
  yield put(ready());
  yield put({ type: appActionTypes.UPSTART.SUCCESS });
}
